import gql from 'graphql-tag';

export const claimPhoneNumber = gql`
  mutation claimPhoneNumber($phoneNumber: String!, $newLoyaltyId: String!) {
    ctgLoyaltyClaimPhoneNumber(phoneNumber: $phoneNumber, newLoyaltyId: $newLoyaltyId)
  }
`;
